/*
 * AppConfig - Service Configuration Object: resource for the root application's app config variables
 *
 */

export class AppConfig {

  apiBaseUrl: string;
  apiApplicationId: string;
  redirectUrl: string;

  constructor(apiBaseUrl: string, apiApplicationId: string, redirectUrl: string) {
    this.apiBaseUrl = apiBaseUrl;
    this.apiApplicationId = apiApplicationId;
    this.redirectUrl = redirectUrl;
  }

}